import { LoadingStatusType, PeakPayrollExceptionCode, TypeComponentNoti } from "@/enums/enums";
import { GetErrorMessageByPayrollExceptionCode } from "@/helper/exceptionCodeHelper";
import {
  SetHeaderPositionTable,
  SetTapsPositionTable,
  ToPositionModel,
  ValidateCreatePositionTemplate,
} from "@/helper/positionHelper";
import { i18n } from "@/i18n";
import { PositionModel } from "@/model/position/positionModel";
import API from "@/service/Index";
import {
  ConvertToPositionDetail,
  ConvertToPositionList,
  ConvertToPositionTable,
} from "@/service/position/positionFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Position extends VuexModule {
  public positionCreateId = 0;
  public createOrUpdatePositionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public positionTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public positionTableList: any = [];
  public headerPositionTable: any = [];
  public tapsPositionTable: any = [];
  public positionDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public positionDetail: any = null;
  public positionListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public positionSuggestionCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public positionSuggestionCode = "";

  get getPositionCreateId(): number {
    return this.positionCreateId;
  }
  get getCreateOrUpdatePositionLoadingStatus(): LoadingStatusType {
    return this.createOrUpdatePositionLoadingStatus;
  }
  get getPositionTableLoadingStatus(): LoadingStatusType {
    return this.positionTableLoadingStatus;
  }
  get getPositionTableList(): any {
    return this.positionTableList;
  }

  get getHeaderPositionTable(): any {
    return this.headerPositionTable;
  }
  get getTapsPositionTable(): any {
    return this.tapsPositionTable;
  }
  get getPositionDetailLoadingStatus(): LoadingStatusType {
    return this.positionDetailLoadingStatus;
  }
  get getPositionDetail(): any {
    return this.positionDetail;
  }
  get getPositionListLoadingStatus(): LoadingStatusType {
    return this.positionListLoadingStatus;
  }
  get getPositionSuggestionCodeLoadingStatus(): LoadingStatusType {
    return this.positionSuggestionCodeLoadingStatus;
  }
  get getPositionSuggestionCode(): string {
    return this.positionSuggestionCode;
  }
  @Mutation
  public MutationPositionCreate(position: any) {
    this.positionCreateId = position.id;
  }
  @Mutation
  public MutationCreateOrUpdatePositionLoadingStatus(status: LoadingStatusType) {
    this.createOrUpdatePositionLoadingStatus = status;
  }
  @Mutation
  public MutationPositionTableLoadingStatus(status: LoadingStatusType) {
    this.positionTableLoadingStatus = status;
  }
  @Mutation
  public MutationGetPositionTable(input: any) {
    this.tapsPositionTable = SetTapsPositionTable(input.table.count);
    this.headerPositionTable = SetHeaderPositionTable(input.tableViewModel);
    this.positionTableList = input.table.tableList;
  }
  @Mutation
  public MutationPositionDetailLoadingStatus(status: LoadingStatusType) {
    this.positionDetailLoadingStatus = status;
  }
  @Mutation
  public MutationPositionDetail(positionDetail: any) {
    this.positionDetail = positionDetail;
  }

  @Mutation
  public MutationPositionListLoadingStatus(status: LoadingStatusType) {
    this.positionListLoadingStatus = status;
  }

  @Mutation
  public MutationSetPositionSuggestionCodeLoadingStatus(loadingStatus: LoadingStatusType) {
    this.positionSuggestionCodeLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationPositionSuggestionCode(code: string) {
    this.positionSuggestionCode = code;
  }
  @Action
  public DoGetPositionTable(input: any) {
    if (this.positionTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationPositionTableLoadingStatus", LoadingStatusType.Loading);
      API.PositionService.DoGetPositionTable(input.departmentId, input.positionTableViewModel).then(
        (resGetPositionTable) => {
          if (resGetPositionTable.status.IsSuccess()) {
            const table = ConvertToPositionTable(resGetPositionTable.data.table);
            const _input = {
              tableViewModel: input.positionTableViewModel,
              table: table,
            };
            this.context.commit("MutationGetPositionTable", _input);
          }

          this.context.commit("MutationPositionTableLoadingStatus", LoadingStatusType.Success);
        }
      );
    }
  }

  @Action
  public DoGetPositionDetail(positionId: number) {
    if (this.positionDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationPositionDetailLoadingStatus", LoadingStatusType.Loading);
      API.PositionService.DoGetPositionDetail(positionId).then((resPositionDetail) => {
        if (resPositionDetail.status.IsSuccess()) {
          const detail = ConvertToPositionDetail(resPositionDetail.data.detail);
          this.context.commit("MutationPositionDetail", detail);
        }

        this.context.commit("MutationPositionDetailLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreatePosition(createPositionTemplate: any) {
    if (this.createOrUpdatePositionLoadingStatus !== LoadingStatusType.Loading) {
      const validateCreatePositionTemplate = ValidateCreatePositionTemplate(createPositionTemplate);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (validateCreatePositionTemplate) {
        this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Loading);
        const positionModel: PositionModel = ToPositionModel(createPositionTemplate);

        API.PositionService.DoCreatePosition(positionModel).then((resCreatePosition) => {
          if (resCreatePosition.data.responseCode.IsSuccess()) {
            this.context.commit("MutationPositionCreate", resCreatePosition.data.position);
            inputAlert.alertMessage = i18n.t("Create_Message_Success", {
              message: i18n.t("Position") + " #" + positionModel.code,
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("Department/MutationResetDepartmentList", { root: true });
            this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Success);
          } else if (resCreatePosition.data.exception.code == PeakPayrollExceptionCode.CodeDuplicated) {
            createPositionTemplate.code.validateError = true;
            inputAlert.alertMessage = i18n.t("Exceptions_Notification.CodeDuplicated", { text: i18n.t("Department") });
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.None);
          } else if (resCreatePosition.data.exception.code == PeakPayrollExceptionCode.CodeIsEmpty) {
            createPositionTemplate.code.validateError = true;
            inputAlert.alertMessage = i18n.t("Exceptions_Notification.CodeIsEmpty", { text: i18n.t("Department") });
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.None);
          } else {
            inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resCreatePosition.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.None);
          }
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
    }
  }

  @Action
  public DoUpdatePosition(createPositionTemplate: any) {
    if (this.createOrUpdatePositionLoadingStatus !== LoadingStatusType.Loading) {
      const validateCreatePositionTemplate = ValidateCreatePositionTemplate(createPositionTemplate);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (validateCreatePositionTemplate) {
        this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Loading);
        const positionModel: PositionModel = ToPositionModel(createPositionTemplate);

        API.PositionService.DoUpdatePosition(positionModel).then((resUpdatePosition) => {
          if (resUpdatePosition.data.responseCode.IsSuccess()) {
            inputAlert.alertMessage = i18n.t("Update_Message_Success", {
              message: i18n.t("Position") + " #" + positionModel.code,
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("Department/MutationResetDepartmentList", { root: true });
            this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Success);
          } else {
            inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resUpdatePosition.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.None);
          }

          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
    }
  }

  @Action
  public DoUpdatePositionDeleted(positionDetail: any) {
    if (this.createOrUpdatePositionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Loading);
      API.PositionService.DoUpdatePositionDeleted(positionDetail.id).then((resUpdatePositionDeleted) => {
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };
        if (resUpdatePositionDeleted.status.IsSuccess()) {
          if (resUpdatePositionDeleted.data.responseCode.IsSuccess()) {
            inputAlert.alertMessage = i18n.t("Remove_Message_Success", {
              message: i18n.t("Position") + " #" + positionDetail.code,
            });
            this.context.commit("Department/MutationResetDepartmentList", { root: true });
          } else {
            inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resUpdatePositionDeleted.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
          }
        } else {
          inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resUpdatePositionDeleted.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.Error;
        }
        this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      });
    }
  }

  @Action
  public DoUpdatePositionArchived(positionDetail: any) {
    if (this.createOrUpdatePositionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Loading);

      API.PositionService.DoUpdatePositionArchived(positionDetail).then((resUpdatePositionArchived) => {
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };
        if (resUpdatePositionArchived.status.IsSuccess()) {
          inputAlert.alertMessage = positionDetail.isArchived
            ? i18n.t("Off_Message_Success", { message: i18n.t("Position") + " #" + positionDetail.code })
            : i18n.t("On_Message_Success", { message: i18n.t("Position") + " #" + positionDetail.code });
          this.context.commit("Department/MutationResetDepartmentList", { root: true });
          this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.None);
        } else {
          inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resUpdatePositionArchived.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.Error;
          this.context.commit("MutationCreateOrUpdatePositionLoadingStatus", LoadingStatusType.Fail);
        }
        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      });
    }
  }

  @Action
  public DoGetPositionList(departmentId: number) {
    if (this.positionListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationPositionListLoadingStatus", LoadingStatusType.Loading);
      API.PositionService.DoGetPositionList(departmentId).then((resPositionList) => {
        if (resPositionList.status.IsSuccess()) {
          const positionList = ConvertToPositionList(resPositionList.data.positionList);
          this.context.commit(
            "Department/MutationSetPositionBydepartmentId",
            {
              departmentId: departmentId,
              positionList: positionList,
            },
            { root: true }
          );
        }

        this.context.commit("MutationPositionListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPositionSuggestionCode(departmentId: number) {
    if (this.positionSuggestionCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetPositionSuggestionCodeLoadingStatus", LoadingStatusType.Loading);
      API.PositionService.DoGetPositionSuggestionCode(departmentId).then((resPositionSuggestionCode) => {
        if (resPositionSuggestionCode.status.IsSuccess()) {
          this.context.commit("MutationPositionSuggestionCode", resPositionSuggestionCode.data.code);
        }

        this.context.commit("MutationSetPositionSuggestionCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
